
(function ($) {
  "use strict";

  Drupal.behaviors.accordion = {
    attach: function (context, settings) {
      $(function() {
        $('.js-accordion', context).accordion();
      });
    }
  };

})(jQuery);
